module.exports = __webpack_public_path__ + "img/stars-bg-desktop.777e1d3.webp";